import React from 'react'

const Footer = () => {
  return (
      <footer className="px-4 py-3 border-t border-slate-200 bg-white/90 text-[0.75rem] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
        <div className="flex flex-col gap-0.5">
          <span>© {new Date().getFullYear()}Gulf.Deals</span>
          <span className="text-slate-500">Helping UAE shoppers find smarter in-store deals.</span>
        </div>
        <nav className="flex flex-wrap gap-3 text-slate-500">
          <button className="hover:text-indigo-600" type="button">
            About
          </button>
          <button className="hover:text-indigo-600" type="button">
            Terms
          </button>
          <button className="hover:text-indigo-600" type="button">
            Privacy
          </button>
          <button className="hover:text-indigo-600" type="button">
            Contact
          </button>
        </nav>
      </footer>
  )
}

export default Footer
